
import MaleIcon from '@/src/assets/male-solid.svg?react';
import FemaleIcon from '@/src/assets/female-solid.svg?react'
import PremiumActiveIcon from '@/src/assets/crown-vip-filled-24.svg?react';

// import { ReactComponent as NoPremiumActiveIcon } from '../../assets/chess-pawn-solid.svg'
// import { ReactComponent as ZombieIcon } from '../../assets/zombie-sign.svg'
import ZombieIcon from '@mui/icons-material/HourglassEmptyOutlined';
import AdminBlockedIcon from '@mui/icons-material/CancelOutlined';
//import AdminBlockedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
// import OkAccountIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import OkAccountIcon from '@mui/icons-material/ThumbUpAltOutlined';
// import VisibilityOnIcon from '@mui/icons-material/VisibilityOutlined';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import VerifiedIcon from '@mui/icons-material/DoneOutlined';
import NotVerifiedIcon from '@mui/icons-material/CloseOutlined';
import SponsorIcon from '@mui/icons-material/MonetizationOnOutlined';
// import NotSponsorIcon from '@mui/icons-material/MoneyOffOutlined';
import AdminNotesIcon from '@mui/icons-material/ViewHeadlineOutlined';

import ProfileInvalidIcon from '@mui/icons-material/PersonOffOutlined';
import ProfileValidIcon from '@mui/icons-material/AccountBoxOutlined';
import { Box, SvgIcon, Tooltip, TooltipProps } from '@mui/material';
import { FieldProps, useRecordContext } from 'react-admin';



export default function StatusField(props: Omit<FieldProps, "source">) {
    const record = useRecordContext();
    if (record) {
        const { profile, adminBlocked, verified, profileValid, premium, adminData } = record;
        const { gender, isSponsor } = profile;


        return (
            <Box display="flex">
                {verified
                    ? <TT title="Verified"><VerifiedIcon color='success' /></TT>
                    : <TT title="Unverified"><NotVerifiedIcon color='warning' /></TT>
                }
                {profileValid
                    ? <TT title="Profile Valid"><ProfileValidIcon color='success' /></TT>
                    : <TT title="Profile invalid"><ProfileInvalidIcon color='warning' /></TT>
                }
                {!gender
                    ? <ZombieIcon color='disabled' />
                    : <SvgIcon component={gender === "male" ? MaleIcon : FemaleIcon} viewBox="0 0 256 512"
                        htmlColor={gender === "male" ? "royalblue" : gender === "female" ? "hotpink" : 'grey'} />
                }
                {isSponsor ? <TT title="Sponsor"><SponsorIcon htmlColor='blue' /></TT> : <TT title="Not sponsor"><SponsorIcon color='disabled' /></TT>}
                {premium?.isActive
                    ? <SvgIcon component={PremiumActiveIcon} htmlColor='#A383FF' />
                    : <SvgIcon component={PremiumActiveIcon} color='disabled' />}


                {adminBlocked
                    ? <TT title="Blocked"><AdminBlockedIcon color='error' /></TT>
                    : <TT title="Account OK"><OkAccountIcon color='success' /></TT>}
                {adminData?.notes ? <TT title={adminData.notes}><AdminNotesIcon /></TT> : <></>}
            </Box >
        )
    }
    return null;
}

// interface IconWithTooltipProps {
//     title: string,
//     icon: SvgIcon
// }
const TT = (props: TooltipProps) => {
    return <Tooltip {...props} />
}